import type { TranslationInterface } from '.';

export const RussianLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Напишите сообщение...',
  your_issue_has_been_resolved: 'Ваша проблема решена!',
  new_conversation: 'Новый разговор',
  welcome_screen_title: 'Добро пожаловать в чат поддержки',
  welcome_screen_description:
    'Мы здесь, чтобы помочь! Начните разговор, и мы ответим вам как можно скорее.',
  your_name_placeholder: 'Ваше имя',
  your_email_placeholder: 'Ваш адрес электронной почты',
  start_chat_button: 'Связаться с поддержкой',
  start_chat_button_loading: 'Подключение...',
  i_need_more_help: 'Мне нужна дополнительная помощь',
  this_was_helpful: 'Это было полезно',
  optional: 'Необязательно',
  no_conversations_yet: 'Пока нет разговоров',
  back_to_conversations: 'Назад к разговорам',
  closed_conversations: 'Закрытые разговоры',
  csat_title: 'Как прошёл ваш разговор?',
  csat_submitted_title: 'Вы оценили разговор как',
  csat_feedback_placeholder: 'Расскажите подробнее... (необязательно)',
  follow_up_placeholder: 'Уточнить…',
  companion_layout_label: 'Макет',
  companion_layout_floating: 'Плавающий',
  companion_layout_sidebar: 'Боковая панель',
  companion_layout_fullscreen: 'На весь экран',
  companion_close: 'Закрыть',
  companion_history: 'История разговоров',
  companion_expand_chat: 'Развернуть чат',
  companion_sidebar_dock_label: 'Закрепление',
  companion_sidebar_side_label: 'Сторона',
  companion_sidebar_left: 'Слева',
  companion_sidebar_right: 'Справа',
  companion_resize_chat: 'Изменить размер чата',
  scroll_to_bottom: 'Прокрутить вниз',
  thinking: 'Думаю…',
  running: 'Выполняется…',
  steps: 'шаги',
  step_arguments: 'Аргументы',
  step_result: 'Результат',
  attach_files:
    'Прикрепить изображения, видео, PDF-файлы или таблицы (максимальный размер 25 МБ)',
  mark_page_active:
    'Нажмите на элемент страницы, чтобы отметить его — Esc для отмены',
  mark_page: 'Отметьте элемент на странице, чтобы задать вопрос о нём',
  stop_response: 'Остановить ответ',
  copy_reply: 'Скопировать ответ',
  mentions_empty: 'Ничего не найдено',
  copied: 'Скопировано',
  send_message: 'Отправить сообщение',
  upload_failed: 'Не удалось загрузить: {error}',
  remove_attachment: 'Удалить вложение',
  json_no_items: 'Нет элементов',
  json_no_data: 'Нет данных',
  json_no_chart_data: 'Нет данных для диаграммы',
  json_unsupported: 'Не поддерживается: {type}',
  json_see_less: 'Показать меньше',
  json_phone_agent: 'Телефонный агент',
  json_phone_agent_test: 'Проверить через веб',
  page_context_remove: 'Убрать контекст страницы',
  json_see_more: 'Показать ещё {count}',
  queued_label: '{count} В очереди',
  remove_queued_message: 'Удалить сообщение из очереди',
  send_queued_now: 'Отправить сообщения из очереди сейчас',
  turn_failed_message: 'Что-то пошло не так, и ответ не пришёл.',
  turn_failed_retry: 'Повторить попытку',
  page_mark_hint: 'Нажмите на элемент, чтобы отметить его',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Рамка',
  page_mark_shape_circle: 'Круг',
  page_mark_shape_arrow: 'Стрелка',
  page_mark_shape_bracket: 'Скобка',
  page_mark_shape_underline: 'Подчёркивание',
  page_mark_shape_highlight: 'Выделение',
  page_mark_shape_strike_through: 'Зачёркивание',
  page_mark_shape_crossed_off: 'Перечёркивание крестом',
  page_mark_shape_aria: 'Форма отметки: {shape}',
  page_mark_note_placeholder: 'Добавить заметку… (Enter, чтобы прикрепить)',
  page_mark_attach: 'Прикрепить отметку',
  page_mark_remove: 'Удалить {label}',
  page_mark_region: 'Отмеченная область',
  page_mark_default_message: 'Что это?',
  file_rejected: 'Тип файла не поддерживается или файл слишком большой.',
  dictate: 'Диктовать',
  stop_dictation: 'Остановить диктовку',
  dictation_mic_blocked: 'Разрешите доступ к микрофону, чтобы диктовать',
  dictation_unavailable: 'Диктовка сейчас недоступна',
  questions_back: 'Назад',
  questions_next: 'Далее',
  questions_send: 'Отправить',
  questions_type_answer: 'Напишу сам',
  questions_answer_placeholder: 'Напишите ваш ответ…',
  close_conversation_title: 'Закрыть разговор',
  close_conversation_description:
    'Вы уверены, что хотите закрыть этот разговор?',
  close_conversation_cancel: 'Нет',
  close_conversation_confirm: 'Да',
  dialog_close: 'Закрыть',
  zoom_in: 'Увеличить',
  zoom_out: 'Уменьшить',
  reset_zoom: 'Сбросить масштаб',
  support_chat_aria_label: 'Чат поддержки',
};
